import { useLocation } from 'react-router-dom';
import useContactSupport from '@/hooks/useContactSupport';
import { Icons } from '@/utils/Icons';

const SupportButton = () => {
  const { handleWhatsAppSupportClick, handleTelegramSupportClick, handleInstagramSupportClick } =
    useContactSupport();
  const { pathname } = useLocation();

  if (pathname !== '/home') {
    return null;
  }

  return (
    <div className="fixed bottom-[calc(72px+env(safe-area-inset-bottom))] right-4 z-50 xl:bottom-4 flex flex-col items-center gap-2">
      {/* WhatsApp and Instagram, sized and animated like the Telegram button */}
      <button
        type="button"
        onClick={handleWhatsAppSupportClick}
        aria-label="Chat with us on WhatsApp"
        className="transition-transform duration-200 hover:scale-110"
      >
        <span className="flex size-10 animate-support-zoom items-center justify-center rounded-full bg-surface p-1.5 shadow-lg">
          <img src="/icons/whatsapp.png" alt="" className="size-full object-contain" />
        </span>
      </button>
      <button
        type="button"
        onClick={handleInstagramSupportClick}
        aria-label="Follow us on Instagram"
        className="transition-transform duration-200 hover:scale-110"
      >
        <span className="flex size-10 animate-support-zoom items-center justify-center rounded-full bg-instagram text-body-inverse shadow-lg">
          <Icons.instagram className="size-6" />
        </span>
      </button>

      {/* Telegram */}
      <button
        type="button"
        onClick={handleTelegramSupportClick}
        aria-label="Contact support on Telegram"
        className="transition-transform duration-200 hover:scale-110"
      >
        <img
          src="/icons/teligram.webp"
          alt="Telegram Support"
          className="size-10 object-contain animate-support-zoom"
        />
      </button>
    </div>
  );
};

export default SupportButton;
